<script lang="ts" setup>
import { ref } from "vue";

import ViTable from "@/components/elements/vi-table/vi-table.vue";
import ViSelect from "@/components/elements/vi-select/vi-select.vue";
import ViBarChart from "@/components/elements/vi-charts/bar/vi-bar-chart.vue";

const selectedSDG = ref("a87dfga");
const sdgList = ref([
  {
    uid: "a87dfga",
    value: "a87dfga",
    label: "SDG 1: Poverty",
  },
]);
const data = ref({
  labels: ["Impact Score", "Positive Impact", "Negative Impact"],
  datasets: [
    {
      axis: "y",
      data: [25, 27, -5],
      backgroundColor: ["#4F8FF7", "#2CBFAF", "#E66E79"],
    },
  ],
});
const options = ref({
  indexAxis: "y",
  barThickness: 80,
  scales: {
    x: {
      min: -100,
      max: 100,
    },
  },
  options: {
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        color: "#585868",
        font: {
          size: 13,
          weight: 600,
        },
      },
    },
  },
});

const rows = ref([
  {
    company: "Pixelmatters",
    impactScore: 30,
    positiveImpact: "+35",
    negativeImpact: "-5",
    actions: "",
  },
  {
    company: "Uniplaces",
    impactScore: 30,
    positiveImpact: "+35",
    negativeImpact: "-5",
    actions: "",
  },
  {
    company: "757 Angels",
    impactScore: 30,
    positiveImpact: "+35",
    negativeImpact: "-5",
    actions: "",
  },
]);
const columns = ref([
  {
    label: "Company",
    accessor: "company",
  },
  {
    label: "Impact Score",
    accessor: "impactScore",
  },
  {
    label: "Positive Impact",
    accessor: "positiveImpact",
  },
  {
    label: "Negative Impact",
    accessor: "negativeImpact",
  },
]);
</script>

<template>
  <div class="sdg-dashboard-by-sdg">
    <div class="header">
      <div class="header-title">SDG 1: Poverty</div>
      <div class="header-list">
        <span>SELECT SDG</span>
        <ViSelect :options="sdgList" :selected-option="selectedSDG" />
      </div>
    </div>
    <div class="chart">
      <div class="chart__header">
        <span class="chart__title">Impact across all companies</span>
        <span class="chart__link">How impact is measured</span>
      </div>
      <ViBarChart
        :data="data"
        :scales="options.scales"
        :index-axis="options.indexAxis"
        :bar-thickness="options.barThickness"
        :options="options.options"
      />

      <ViTable :columns="columns" :data="rows" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.sdg-dashboard-by-sdg {
  padding: 32px;

  .header {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }

  .header-title {
    color: var(--color-text);
    font-size: var(--text-xl);
    font-weight: var(--font-semibold);
  }

  .header-list {
    gap: 8px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;

    span {
      display: block;
      white-space: nowrap;
      font-size: var(--text-sm);
      color: var(--color-text);
      font-weight: var(--font-semibold);
    }
  }

  .chart {
    width: 100%;
    min-height: 400px;
    margin-top: 24px;
    padding: 24px;
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    &__header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
    }

    &__title {
      color: var(--color-text);
      font-size: var(--text-xl);
      font-weight: var(--font-medium);
    }

    :deep(.vi-table) {
      margin-top: 32px;
    }
  }
}
</style>
